/**
 * Created by Ning Jiang on 4/6/2017.
 */

import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {WGParsedGameData} from "../server/data/WGParsedGameData";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {
    Presentation,
    PresentationState
} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ReelEngineManager} from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineManager";
import {IReelSymbolStates, WGSpriteSymbol} from "../engine/Symbol/WGSpriteSymbol";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WGGameConfig} from "../WGGameConfig";
import {DisplayObject} from "pixi.js";
import {WarriorGraveyardGameModuleConfig} from "../WarriorGraveyardGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {WarriorGraveyard} from "../WarriorGraveyard";

export class IndiSymWinHighlightPresentation extends Presentation {
    private gameData: WGParsedGameData;

    public checkForActivation(data: WGParsedGameData): boolean {
        this.gameData = data;
        return WarriorGraveyard.api.gameClientConfiguration.displayIndividualWinsInGame && (this.gameData.originalBetLinesData.length > 0);
    }

    stopPresentation() {
        this.PresentationState.set(PresentationState.INACTIVE);
    }

    skipPresentation() {
        this.pTimeline.timeScale(10);
    }

    getPresentation(): void {
        // EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        const betLineWins = <IBetLineWinData[]>this.gameData.betWins;
        betLineWins.forEach((betLineWinData, idx) => {
            const durr: number = this.pTimeline.duration();
            let con: PIXI.Container;
            con = this.getWinWaysCont(betLineWinData);
            StageManager.getLayer(WGGameConfig.instance.LAYERS.INDI_SYM_WIN.name).addChild(con);
            this.pTimeline.add( WarriorGraveyardGameModuleConfig.betlineWinBox.playWinBoxAnimationForSymIndiWin(betLineWinData,con).timeScale(3),durr);

            this.pTimeline.add(() => {
                con.visible=true;
            }, durr);

            this.pTimeline.add(() => {
                StageManager.getLayer(WGGameConfig.instance.LAYERS.INDI_SYM_WIN.name).removeChild(con);
            });
        })
        this.pTimeline.add(() => {
            this.PresentationState.set(PresentationState.END);
        })
    }

    private getWinNumberText(amt: number): string {
        let str: string = Currency.formatValue(amt);
        return str;
    }

    private getWinWaysCont(betLineData: IBetLineWinData): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container();
        const winNumber: PIXI.BitmapText = new PIXI.BitmapText(this.getWinNumberText(betLineData.amount),  {
            fontName: "WGNumbersWinCountUp",
            fontSize: 8
        });
        while (winNumber.width > GameConfig.instance.SYMBOL_WIDTH) {
            --winNumber.fontSize;
        }
        winNumber.pivot.set(winNumber.width/2,winNumber.height/2);
        cont.addChild(winNumber);
        cont.visible=false;
        return cont;
    }
}